import { render, staticRenderFns } from "./FormEditor.vue?vue&type=template&id=f47105cc&scoped=true"
import script from "./FormEditor.vue?vue&type=script&lang=js"
export * from "./FormEditor.vue?vue&type=script&lang=js"
import style0 from "./FormEditor.vue?vue&type=style&index=0&id=f47105cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f47105cc",
  null
  
)

export default component.exports